import React from 'react';
import cn from 'classnames';

var defaultColors = {"component":"skeleton__component_hlcot","animate":"skeleton__animate_hlcot","background":"skeleton__background_hlcot"};
require('./default.css');

var styles = {"component":"skeleton__component_1c1ht","allowBackdropBlur":"skeleton__allowBackdropBlur_1c1ht","borderRadius-0":"skeleton__borderRadius-0_1c1ht","borderRadius-2":"skeleton__borderRadius-2_1c1ht","borderRadius-4":"skeleton__borderRadius-4_1c1ht","borderRadius-6":"skeleton__borderRadius-6_1c1ht","borderRadius-10":"skeleton__borderRadius-10_1c1ht","borderRadius-12":"skeleton__borderRadius-12_1c1ht","borderRadius-16":"skeleton__borderRadius-16_1c1ht","borderRadius-20":"skeleton__borderRadius-20_1c1ht","borderRadius-24":"skeleton__borderRadius-24_1c1ht","borderRadius-32":"skeleton__borderRadius-32_1c1ht","borderRadius-36":"skeleton__borderRadius-36_1c1ht","borderRadius-64":"skeleton__borderRadius-64_1c1ht","borderRadius-pill":"skeleton__borderRadius-pill_1c1ht","animate":"skeleton__animate_1c1ht"};
require('./index.css');

var invertedColors = {"component":"skeleton__component_rqg57","animate":"skeleton__animate_rqg57","background-inverted":"skeleton__background-inverted_rqg57"};
require('./inverted.css');

var colorStyles = {
    default: defaultColors,
    inverted: invertedColors,
};
var Skeleton = function (_a) {
    var _b;
    var visible = _a.visible, _c = _a.animate, animate = _c === void 0 ? true : _c, className = _a.className, dataTestId = _a.dataTestId, children = _a.children, style = _a.style, allowBackdropBlur = _a.allowBackdropBlur, _d = _a.colors, colors = _d === void 0 ? 'default' : _d, _e = _a.borderRadius, borderRadius = _e === void 0 ? 8 : _e;
    if (visible) {
        return (React.createElement("div", { className: cn(styles.component, colorStyles[colors].component, (_b = {},
                _b[styles.animate] = animate,
                _b[colorStyles[colors].animate] = animate,
                _b[styles.allowBackdropBlur] = allowBackdropBlur,
                _b[styles["borderRadius-".concat(borderRadius)]] = borderRadius !== 8,
                _b), className), style: style, "data-test-id": dataTestId }, children));
    }
    return (React.createElement("div", { "data-test-id": dataTestId, className: className, style: style }, children));
};

export { Skeleton };
